export default "__VITE_ASSET__b3e93a69__"